var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPartiesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61877 14.105C4.61877 15.1997 5.34715 16.1261 6.35301 16.4797V19.1576H4.61877V20.8418H9.82148V19.1576H8.08725V16.4797C9.0931 16.1261 9.82148 15.1997 9.82148 14.105V7.36816H4.61877V14.105ZM6.35301 9.05237H8.08725V11.5787H6.35301V9.05237ZM6.35301 13.2629H8.08725V14.105C8.08725 14.5682 7.69704 14.9471 7.22013 14.9471C6.74321 14.9471 6.35301 14.5682 6.35301 14.105V13.2629Z",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9147 9.50737L19.0823 9.2379C18.7267 9.12 18.4926 8.8 18.4926 8.43789V4.84211C18.4926 4.37895 18.1024 4 17.6255 4H15.0241C14.5472 4 14.157 4.37895 14.157 4.84211V8.44632C14.157 8.80842 13.9229 9.12842 13.5674 9.24632L12.7349 9.51579C12.0326 9.75158 11.5557 10.3916 11.5557 11.1158V19.1579C11.5557 20.0842 12.3361 20.8421 13.2899 20.8421H19.3597C20.3136 20.8421 21.094 20.0842 21.094 19.1579V11.1074C21.094 10.3832 20.617 9.74316 19.9147 9.50737ZM15.8913 5.68421H16.7584V6.52632H15.8913V5.68421ZM19.3597 19.1579H13.2899V17.4737H19.3597V19.1579ZM19.3597 15.7895H13.2899V14.1053H19.3597V15.7895ZM19.3597 12.4211H13.2899V11.1074L14.1137 10.8379C15.1802 10.5011 15.8913 9.53263 15.8913 8.44632V8.21053H16.7584V8.44632C16.7584 9.53263 17.4694 10.5011 18.536 10.8463L19.3597 11.1074V12.4211Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1238 21.7071L3.58911 3.70711L4.31722 3L22.8519 21L22.1238 21.7071Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPartiesIcon);
export default __webpack_public_path__ + "static/media/NoPartiesIcon.07edb2ade1f3efa5e69cb0c88260b8d5.svg";
export { ForwardRef as ReactComponent };